import Command from '@ckeditor/ckeditor5-core/src/command';
import LibraryItemStore from '../../library-item-store';

export default class AddLibraryItemCommand extends Command {
  execute(item) {
    const editor = this.editor;
    LibraryItemStore.add(item);
    editor.execute('placeholder', { id: item.id });
    editor.editing.view.focus();
  }

  refresh() {
    this.isEnabled = true;
  }
}
